import { ReactElement } from "react";
import { Box } from "@chakra-ui/react";
import { ReactSVG } from "react-svg";
import { KOKORO_IMAGE_URL } from "../../../environments";
import { setSVGFillColor } from "../../../utils/svgHelper";
import { useColorToken } from "../../../hooks/useColorToken";

interface KokoroSvgProps {
  imageIndex: number;
}

export function KokoroSvg({
  imageIndex,
}: Readonly<KokoroSvgProps>): ReactElement {
  const themeLv1 = useColorToken("primary.theme_lv1");
  const themeLv2 = useColorToken("primary.theme_lv2");
  const themeLv3 = useColorToken("primary.theme_lv3");
  const meter_text_lv1 = useColorToken("result.meter_text_lv1");
  const meter_text_lv2 = useColorToken("result.meter_text_lv2");
  const meter_needle = useColorToken("result.meter_needle");

  if (!KOKORO_IMAGE_URL.at(imageIndex)) {
    return <Box pb={10} />;
  }

  return (
    <Box pb={10}>
      <ReactSVG
        src={KOKORO_IMAGE_URL[imageIndex]}
        beforeInjection={(svg) => {
          const title = document.createElementNS(
            "http://www.w3.org/2000/svg",
            "title",
          );
          title.textContent = "kokoro";
          svg.prepend(title);
          svg.setAttribute("width", "100%");
          svg.setAttribute("height", "100%");
          setSVGFillColor(svg, ".cls-theme1", themeLv1);
          setSVGFillColor(svg, ".cls-theme2", themeLv2);
          setSVGFillColor(svg, ".cls-theme3", themeLv3);
          setSVGFillColor(svg, ".cls-text1", meter_text_lv1);
          setSVGFillColor(svg, ".cls-text2", meter_text_lv2);
          setSVGFillColor(svg, ".cls-needle", meter_needle);
        }}
      />
    </Box>
  );
}
